import React from 'react';
import { Navigate } from 'react-router-dom';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { Skeleton } from '@/components/ui/skeleton';

interface FeatureGateProps {
  featureKey: string;
  children: React.ReactNode;
  redirectTo?: string;
}

/**
 * A component that gates access to features based on feature flags.
 * If the feature is disabled, redirects to the specified path (default: /services).
 */
export function FeatureGate({ featureKey, children, redirectTo = '/services' }: FeatureGateProps) {
  const { enabled, loading } = useFeatureFlag(featureKey);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="space-y-4 w-full max-w-md px-4">
          <Skeleton className="h-8 w-3/4 mx-auto" />
          <Skeleton className="h-4 w-1/2 mx-auto" />
          <Skeleton className="h-32 w-full" />
        </div>
      </div>
    );
  }

  if (!enabled) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}
